import { connect } from 'react-redux';
import { callPingRoutine } from 'redux-state/ducks/app';
import Ping from './ping.component';

const mapDispatchToProps = {
  callPingAction: callPingRoutine.request,
};

export default connect(null, mapDispatchToProps)(Ping);
